import { removeAllocationError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRemoveAllocationError({ uuid }) {
      const res = getState().find(({ allocation }) => uuid === allocation.uuid);

      return res ? res.error : removeAllocationError;
    },
    isRemoveAllocationRequestFailure({ uuid }) {
      const state = getState().find(
        ({ allocation }) => uuid === allocation.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRemoveAllocationRequestPending({ uuid }) {
      const state = getState().find(
        ({ allocation }) => uuid === allocation.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRemoveAllocationRequestSuccess({ uuid }) {
      const state = getState().find(
        ({ allocation }) => uuid === allocation.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
